import React from 'react';
import SubTopicComponent from '../../views/plp/SubTopicComponent';
import ComponentRegistry from '../../model/ComponentRegistry.js';
import proficiencyReportIcon from '../../images/icons/report-proficiency.png';
import practiceReportIcon from '../../images/icons/report-practice.png';

import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import ratingDefaultIcon from '../../images/icons/emojis/rating_default.png';

import ratingBadIcon from '../../images/icons/emojis/bad.gif';
import ratingGoodIcon from '../../images/icons/emojis/good.gif';
import ratingLoveitIcon from '../../images/icons/emojis/loveit.gif';
import ratingNormalIcon from '../../images/icons/emojis/normal.gif';
import ratingVerybadIcon from '../../images/icons/emojis/verybad.gif';

import ratingBadIconSmall from '../../images/icons/emojis/bad_small.png';
import ratingGoodIconSmall from '../../images/icons/emojis/good_small.png';
import ratingLoveitIconSmall from '../../images/icons/emojis/loveit_small.png';
import ratingNormalIconSmall from '../../images/icons/emojis/normal_small.png';
import ratingVerybadIconSmall from '../../images/icons/emojis/verybad_small.png';


export default class ms_SubTopicComponent extends SubTopicComponent{

 getSubTopicBodyContent(){	
	  if(this.props.lessonOnlyMode == false && window.topic_name_in_subtopic_tile_by_schoolprefix && ~window.topic_name_in_subtopic_tile_by_schoolprefix.indexOf(this.getUser().getSchoolPrefix())){
		return(
				<div className="card-body info subtopicbody">
					<h5 className="card-title">{this.props.topicName}</h5>
	      	  	</div>    
		);
	  }
  }

   getBottomItems(){
	  if(this.props.lessonOnlyMode == true){
		 
			  return (
						<div className="row clearfix bottomSection">				  
						  	<div className="col-12 card-bottom text-center nosidepadding showcursor" onClick={this.onSubTopicStartLessons} data-ga={"Post login - "+this.props.gradeName+" - Lessons - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - "+this.getLesssonsActionLabel()}>
							  	<a className="card-link tileLink">
							    	<h5>
					  		     
						  		    {(() => {				  		    	
						  		    	if(this.subtopic.status == "COMPLETED"){
					    		        	 return this.rb("lesson.watched");
					    		        }else if(this.subtopic.status == "IN_PROGRESS"){
					    		        	 return this.rb("home.resume");
					    		        }
						  		    	else{
					    		        	 return this.rb("home.start");
					    		        }
					    		      })()}
					  		    
					  		    </h5>
							     </a>
						  	</div>	    		    	
						</div>
				)
		 
	  }else{
	  	let completedTestRoute = "/report";
	  	let completedPracRoute = "/report";
	  	if(this.subtopic && this.subtopic.testType && (this.subtopic.testType !== 5 && this.subtopic.testType !== 6) ){
	  		completedTestRoute = "/scorecard/"+this.props.subtopic.testId;
	  		completedPracRoute = "/scorecard/"+this.props.subtopic.recommendtestid;
	  	}


		  if(this.subtopic.status == "IN_PROGRESS"){			
			if(this.subtopic.reqTestStatus != "COMPLETED" && this.subtopic.testStatus == "COMPLETED"){	
				return (					
		            
		            <div className="row clearfix bottomSection">	
					  	<a className="col-6 card-bottom text-center borderRight nosidepadding notoppadding showcursor" href={completedTestRoute} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - Report"}>
					  		<div className="card-link tileLink review-cont"><span className="completed-stat-review">{this.rb("report-nav-text")}</span></div>
					  	</a>
						  {this.lockcontent(this.props.subtopic.practiceLocked)}
					  	{/* <a className={"col-6 card-bottom text-center nosidepadding notoppadding showcursor "+classdisabled} onClick={this.onSubTopicStartCP} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - CP - "+this.getStatusActionText()}>
						  	<div className="card-link tileLink">
						    	{
									this.lockcontent(this.props.subtopic.practiceLocked)
								}
				  		    </div>
					  	</a>	    		    	 */}
					</div>
	            )
			}else{
				return (
					<div className="row clearfix bottomSection">				  
					  	<div className="col-12 card-bottom text-center nosidepadding showcursor" onClick={this.onSubTopicStartPT} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - "+this.getStatusActionText()}>
						  	<div className="card-link tileLink">
						    	<h5>
						    	{this.getStatusActionText()}
						    	</h5>
						     </div>
					  	</div>	    		    	
					</div>
				)
			}
		  }else if(this.subtopic.status == "COMPLETED"){
			if(this.props.subtopic.recommendtestid != 0 && this.props.subtopic.recommendtestid != "0"){
				return (				
				        <div className="row clearfix bottomSection">	
						  	<a className="col-6 card-bottom text-center borderRight nosidepadding notoppadding showcursor" href={completedTestRoute} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - Report"}>
						  		<div className="card-link tileLink review-cont"><span className="completed-stat-review">{this.rb("report-nav-text")}</span></div>
						  	</a>
						  	<a className="col-6 card-bottom text-center nosidepadding notoppadding showcursor" href={completedPracRoute} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - CP - Report"}>
						  		<div className="card-link tileLink review-cont">
								  <span className="completed-stat-review">{this.rb("report-nav-text")}</span></div>
						  	</a>	    		    	
						</div>
		        )
			}else{
				return (				
				        <div className="row clearfix bottomSection">	
						  	<a className="col-12 card-bottom text-center borderRight nosidepadding notoppadding showcursor" href={completedTestRoute} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - Report"}>
						  		<div className="card-link tileLink review-cont"><span className="completed-stat-review">{this.rb("report-nav-text")}</span></div>
						  	</a>					    		    	
						</div>
		        )
			}
		  }else{
			return (
					<div className="row clearfix bottomSection">				  
					  	<div className="col-12 card-bottom text-center nosidepadding showcursor" onClick={this.onSubTopicStartPT} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - "+this.getStatusActionText()}>
						  	<a className="card-link tileLink">
						    	<h5>
				  		      {this.getStatusActionText()}
				  		    </h5>
						     </a>
					  	</div>	    		    	
					</div>
			)
		} 
	  }
  }


 render() {
    return (  
    			 
                <div className="card subTopic clearfix">
		    		  <div className="card-img-top subtopic text-center" style={{backgroundColor: this.props.subTopicBoxColor}}>   
		    		  		 {this.getBGImg()}
		    		  </div>
		    		  <div className="card-img-overlay">
	    			    	<div className="card-title">{this.props.subtopic.subTopicName}</div>		    			    
	    			  </div>
	    		       
		               {this.getSubTopicBodyContent()}		               		 
		    		 
			      	  {this.getBottomItems()}
	    		</div>
	    		
    );
  }


}


// WEBPACK FOOTER //
// ./src/vendors/mindstretcher/ms_subtopiccomponent.js